import client from './client';

export interface BrowserScreeningResult {
  screening_mode?: 'free' | 'hard_conditions';
  selected_conditions?: { id: string; text: string }[];
  reasons?: string[];
  strengths?: string[];
  follow_up?: string[];
  recommendation: '适合' | '不适合' | '待人工确认';
  summary: string;
  checks: {
    requirement: string;
    kind: 'hard' | 'soft';
    status: 'met' | 'not_met' | 'unknown';
    evidence: string;
  }[];
  review_required: boolean;
  evaluated_at: string;
}

// 邮箱附件及 BOSS 插件采集的待处理资料；在线正文不等于正式简历附件。
export interface PendingCandidate {
  id: number;
  source_platform?: string;
  browser_source_id?: number | null;
  source_url?: string | null;
  boss_job_key?: string | null;
  boss_job_title?: string | null;
  jd_id?: number | null;
  online_resume?: string | null;
  phone?: string | null;
  email?: string | null;
  screening_result?: BrowserScreeningResult | null;
  screening_stale?: boolean;
  name: string;
  attachment_name: string | null;
  file_path: string | null;
  file_size?: number;
  source_email?: string;
  email_subject?: string;
  email_from?: string;
  email_date?: string;
  status: string;
  candidate_id?: number;
  fetched_by?: number;
  fetched_by_name?: string;
  created_at: string;
}

export interface PendingCandidateListResponse {
  items: PendingCandidate[];
  total: number;
  page: number;
  page_size: number;
  total_pages: number;
}

// 查询待处理候选人列表
export const getPendingCandidateList = async (params: {
  keyword?: string;
  status?: string;
  page?: number;
  page_size?: number;
}): Promise<PendingCandidateListResponse> => {
  const response = await client.get('/pending-candidate/list', { params });
  return response.data;
};

// 手动触发简历抓取邮箱扫描
export const scanResumeMailbox = async (): Promise<{ scanned: number; created: number; message: string }> => {
  const response = await client.post('/pending-candidate/scan');
  return response.data;
};

// 待处理候选人转为正式候选人
export const convertPendingCandidate = async (
  pendingId: number,
  data: { jd_id: number; screening_owner_id: number; channel: string }
): Promise<{ candidate_id: number; pending_id: number }> => {
  const response = await client.post(`/pending-candidate/${pendingId}/convert`, data);
  return response.data;
};

// BOSS 附件经 HR 明确选择岗位和负责人后进入现有正式流程，渠道固定为 Boss直聘。
export const convertBrowserCandidate = async (
  sourceId: number,
  data: { jd_id: number; screening_owner_id: number }
): Promise<{ candidate_id: number; pending_id: number; already_imported: boolean }> => {
  const response = await client.post(`/browser-extension/sources/${sourceId}/convert`, data);
  return response.data;
};

// 删除待处理候选人
export const deletePendingCandidate = async (pendingId: number): Promise<void> => {
  await client.delete(`/pending-candidate/${pendingId}`);
};
